module.exports = __webpack_public_path__ + "img/6.502f9c06.jpg";